import { useMutation } from 'react-query';
import { MoneyCollection } from '../../../interfaces/moneyCollection.interface';
import { GenericResponse } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';
import { queryClient } from '../../APIProvider';
import { getHttpMethod } from '../../helpers';

interface CreateMoneyCollectionResponse extends GenericResponse {
  entity: MoneyCollection;
}

const updateCreateMoneyCollection = async (variables: any): Promise<CreateMoneyCollectionResponse> => {
  const isClone = variables.isClone;
  delete variables.isClone;

  const resp = await apiRQ[getHttpMethod(variables?.id, isClone)]<CreateMoneyCollectionResponse>('/money-collection/', {
    data: variables,
  });

  return resp.data;
};

export const useUpdateCreateMoneyCollection = () => {
  return useMutation<CreateMoneyCollectionResponse, Error>(updateCreateMoneyCollection, {
    onSettled: () => {
      queryClient?.invalidateQueries({ queryKey: ['useMoneyCollectionList'] });
    },
  });
};
